import { createSlice } from "@reduxjs/toolkit";
import { fetchUniversalLedger, fetchUniversalLedgerAccountsBySearch } from "./AccountTransactionThunk";

const initialState = {
  list: [],
  loading: false,
  openingBalance: 0,
  closingBalance: 0,
  searchResults: [],
  loadingSearch: false,
  // ── linked party ──────────────────────────────────────
  linkedParty: null,
  linkedLedgerList: [],
  linkedOpeningBalance: 0,
  linkedClosingBalance: 0,
  filters: {
    accTypeId: null,
    accId: null,
    accName: "",
    fromDate: null,
    toDate: null,
    ledgerType: "without details",
  },
};

const universalLedgerSlice = createSlice({
  name: "universalLedger",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    resetLedger: (state) => {
      state.list = [];
      state.openingBalance = 0;
      state.closingBalance = 0;
      state.linkedParty = null;
      state.linkedLedgerList = [];
      state.linkedOpeningBalance = 0;
      state.linkedClosingBalance = 0;
    },
    clearSearchResults: (state) => {
      state.searchResults = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUniversalLedger.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUniversalLedger.fulfilled, (state, action) => {
        state.loading        = false;
        state.list           = action.payload?.ledger         || [];
        state.openingBalance = action.payload?.opening_balance || 0;
        state.closingBalance = action.payload?.closing_balance || 0;

        // ── linked party ──────────────────────────────────
        const lp = action.payload?.linked_party;
        state.linkedParty          = lp             || null;
        state.linkedLedgerList     = lp?.ledger     || [];
        state.linkedOpeningBalance = lp?.opening_balance || 0;
        state.linkedClosingBalance = lp?.closing_balance || 0;
      })
      .addCase(fetchUniversalLedger.rejected, (state) => {
        state.loading = false;
      })
      .addCase(fetchUniversalLedgerAccountsBySearch.pending, (state) => {
        state.loadingSearch = true;
      })
      .addCase(fetchUniversalLedgerAccountsBySearch.fulfilled, (state, action) => {
        state.loadingSearch  = false;
        state.searchResults  = action.payload || [];
      })
      .addCase(fetchUniversalLedgerAccountsBySearch.rejected, (state) => {
        state.loadingSearch  = false;
        state.searchResults  = [];
      });
  },
});

export const { setFilters, resetLedger, clearSearchResults } =
  universalLedgerSlice.actions;

export default universalLedgerSlice.reducer;